@if (regularExpressionForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="regularExpressionForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <clickatell-form-validation [controlName]="'name'"
            [form]="regularExpressionForm"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="regularExpressionForm" id="name"
              [formControlName]="'name'" placeholder="Enter name"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Description </label>
              </div>
              <clickatell-form-validation [controlName]="'description'"
              [form]="regularExpressionForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="regularExpressionForm" id="description"
                [formControlName]="'description'" placeholder="Enter description"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Variable Name </label>
                </div>
                <clickatell-form-validation [controlName]="'variableName'"
                [form]="regularExpressionForm"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="regularExpressionForm" id="variableName"
                  [formControlName]="'variableName'" placeholder="Enter variable name"/>
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Function Name </label>
                  </div>
                  <clickatell-form-validation [controlName]="'functionName'"
                  [form]="regularExpressionForm"></clickatell-form-validation>
                  <mat-select
                    #functionName
                    class="control-dropdown"
                    id="functionName"
                    [placeholder]="'Select an function'"
                    [formControlName]="'functionName'"
                    (selectionChange)="functionChange(functionName.value)"
                    hideSingleSelectionIndicator>
                    @for (option of functionOptions; track option) {
                      <mat-option [value]="option">
                        {{ option }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
                @if (functionName.value ) {
                  <div>
                    @switch (functionName.value) {
                      @case ('match') {
                        <ng-container [ngTemplateOutlet]="match"></ng-container>
                      }
                      @default {
                        <ng-container [ngTemplateOutlet]="replace"></ng-container>
                      }
                    }
                  </div>
                }
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
          <clickatell-expansion-panel>
            <ng-container header>
              <mat-panel-title>
                Logic
              </mat-panel-title>
            </ng-container>
            <ng-container body>
              <ng-container [formGroup]="regularExpressionForm">
                <div class="control-result">
                  <div class="control-result-header">
                    Yes
                  </div>
                  <div class="control-result-container">
                    <div class="control-div">
                      <label class="control-label">
                        <span class="pont-to">Point To</span>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                      </label>
                      @if (nodeFlowDetails) {
                        <next-selector [canEditFlows]="canEdit.canEditFlows"
                          [selectorType]="'both'"
                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                          [flows]="nodeFlowDetails.flows"
                          [name]="'yes'"
                          [form]="regularExpressionForm"
                          [stepId]="nodeFlowDetails.stepId">
                        </next-selector>
                      }
                    </div>
                  </div>
                </div>
                <div class="control-result">
                  <div class="control-result-header">
                    No
                  </div>
                  <div class="control-result-container">
                    <div class="control-div">
                      <label class="control-label">
                        <span class="pont-to">Point To</span>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                      </label>
                      @if (nodeFlowDetails) {
                        <next-selector [canEditFlows]="canEdit.canEditFlows"
                          [selectorType]="'both'"
                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                          [flows]="nodeFlowDetails.flows"
                          [name]="'no'"
                          [form]="regularExpressionForm"
                          [stepId]="nodeFlowDetails.stepId">
                        </next-selector>
                      }
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
        </div>
      }

      <ng-template #match>
        <div class="control-div" [formGroup]="functionForm">
          <div class="control-label-container">
            <label class="control-label"> Pattern </label>
          </div>
          <clickatell-form-validation [controlName]="'pattern'"
          [form]="functionForm"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="functionForm" id="match-pattern"
            [formControlName]="'pattern'" placeholder="Enter pattern"/>
          </div>
        </ng-template>

        <ng-template #replace>
          <ng-container [formGroup]="functionForm">
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Pattern </label>
              </div>
              <clickatell-form-validation [controlName]="'pattern'"
              [form]="functionForm"></clickatell-form-validation>
              <input class="control-input" activeForm [activeForm]="functionForm" id="replace-pattern"
                [formControlName]="'pattern'" placeholder="Enter pattern"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Replace </label>
                </div>
                <input class="control-input" activeForm [activeForm]="functionForm" id="replace"
                  [formControlName]="'replace'" placeholder="Enter replace"/>
                </div>
              </ng-container>
            </ng-template>

